import React from "react";
import { TextField } from "@mui/material";
const GenericSearchBar = ({ searchQuery, onSearchChange, placeholder = "Search ...", }) => {
    return (React.createElement(TextField, { placeholder: placeholder, size: "small", value: searchQuery, onChange: onSearchChange, fullWidth: true, sx: { margin: "0px 0px 15px 0px" } }));
};
export default GenericSearchBar;
